import React, { useState, useRef, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { format, addDays, subDays } from 'date-fns';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { FiSearch, FiX } from 'react-icons/fi';
import { EventApi } from '@fullcalendar/react';
// servicos
import api from 'services/api';
// components
import Field from 'components/Field';
import Calendar from 'components/Calendar';
import Card from 'components/Card';
import Input from 'components/Input';
import Checkbox from 'components/Checkbox';
import DatePicker from 'components/DatePicker';
import Radio from 'components/Radio';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
// styles
import { Container, Content, RightContent } from './styles';

import { DataFilter, Tipo } from '../../utils/variables';
import { useTheme } from 'styled-components';

interface Event {
  id: number;
  title: string;
  start: Date;
  end: Date;
  allDay: boolean;
  backgroundColor: string;
  borderColor: string;
}
interface FilterSubmit {
  retranca: string;
  tipo: string[];
  setor: string;
  emissora: string[];
}
interface Emissora {
  id: number;
  nome: string;
  siglapromo: string;
}
interface Chamada {
  id: number;
  retranca: string;
  datainicio: Date;
  datafim: Date;
  descricao: string;
  tipo:
    | 'chamada'
    | 'promocional'
    | 'vinheta'
    | 'chpatrocinada'
    | 'apoio'
    | 'campanha'
    | 'campanhapatrocinada'
    | 'videopatrocinado'
    | 'programete'
    | 'afinacao';
}
export default function PromoCalendar() {
  /**
   * USE STATE
   */
  const [loading, setLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [events, setEvents] = useState<Event[]>([]);
  const [selectedEvent, setSelectedEvent] = useState({} as EventApi);
  const [filter, setFilter] = useState({} as FilterSubmit);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>();
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>();
  const [rede, setRede] = useState(true);
  const [todosTipos, setTodosTipos] = useState(true);
  const [emissoras, setEmissoras] = useState([]);
  const [date, setDate] = useState([new Date(), new Date()]);
  const [initialData, setInitialData] = useState({
    retranca: '',
    tipo: DataFilter.tipos.map(t => t.id),
    emissora: [1, 2, 3, 4, 5, 6, 7, 8],
    setor: '',
  });

  /**
   * USE SELECTOR
   */
  const theme = useTheme();

  /**
   * USE REF
   */
  const formFilterRef = useRef<FormHandles>(null);
  const formRef = useRef<FormHandles>(null);

  /**
   * USE CALLBACK
   */
  const handleEventClick = useCallback((event: EventApi) => {
    setShowFilter(true);
    if (event.start && event.end) {
      setSelectedStartDate(event.start);
      setSelectedEndDate(subDays(event.end, 1));
    }
    setSelectedEvent(event);
  }, []);

  const handleChangeDate = useCallback((start: Date, end: Date) => {
    start && end && setDate([start, end]);
  }, []);

  const handleSelectedTipo = useCallback(() => {
    if (formFilterRef.current?.getFieldValue('tipo').length === 9)
      setTodosTipos(true);
    else setTodosTipos(false);
  }, []);

  const handleTodos = useCallback(e => {
    e.preventDefault();
    if (formFilterRef.current) {
      const tipos = formFilterRef.current.getFieldValue('tipo');
      if (tipos.length === DataFilter.tipos.length) {
        formFilterRef.current.clearField('tipo');
        setTodosTipos(false);
      } else {
        // const rede = [1, 2, 3, 4, 5, 6, 7, 8].join();
        formFilterRef.current.setFieldValue(
          'tipo',
          DataFilter.tipos.map(t => t.id),
        );
        setTodosTipos(true);
      }
    }
  }, []);
  const handleSelectedExibidor = useCallback(() => {
    if (formFilterRef.current?.getFieldValue('emissora').length === 8)
      setRede(true);
    else setRede(false);
  }, []);

  const handleRede = useCallback(e => {
    e.preventDefault();
    if (formFilterRef.current) {
      const emissoras = formFilterRef.current.getFieldValue('emissora');
      if (emissoras.length === 8) {
        formFilterRef.current.clearField('emissora');
        setRede(false);
      } else {
        const rede = [1, 2, 3, 4, 5, 6, 7, 8].join();
        formFilterRef.current.setFieldValue('emissora', rede);
        setRede(true);
      }
    }
  }, []);

  const handleSubmit = useCallback((data: FilterSubmit) => {
    setInitialData({
      retranca: data.retranca,
      tipo: data.tipo,
      emissora: data.emissora.map(e => Number(e)),
      setor: data.setor,
    });
    setFilter(data);
  }, []);

  const handleSubmitUpdateDates = useCallback(async () => {
    if (
      selectedEndDate &&
      selectedStartDate &&
      selectedEndDate >= selectedStartDate
    ) {
      try {
        setLoadingUpdate(true);
        const response = await api.put(`/chamadas/${selectedEvent.id}`, {
          datainicio: selectedStartDate,
          datafim: selectedEndDate,
        });
        const res: Chamada = response.data;
        setEvents(prev =>
          prev.map((e: Event) =>
            e.id === res.id
              ? {
                  id: res.id,
                  title: `${res.retranca} (${format(
                    new Date(res.datainicio),
                    'dd/MM',
                  )} - ${format(new Date(res.datafim), 'dd/MM')})`,
                  start: new Date(res.datainicio),
                  end: addDays(new Date(res.datafim), 1),
                  allDay: true,
                  backgroundColor: theme.calendar[res.tipo],
                  textColor: theme.secondaryFontColor,
                  borderColor: 'transparent',
                }
              : e,
          ),
        );
        toast.success(`${res.retranca} atualizado com sucesso`);
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      }
      setLoadingUpdate(false);
    } else {
      toast.error('Verifique as datas');
    }
  }, [
    selectedEndDate,
    selectedEvent.id,
    selectedStartDate,
    theme.calendar,
    theme.secondaryFontColor,
  ]);

  /**
   * USE EFFECT
   */
  useEffect(() => {
    setLoadingUpdate(false);
  }, [selectedEvent]);
  useEffect(() => {
    const controller = new AbortController();
    async function buscaEmissoras() {
      setLoading(true);
      try {
        const { data } = await api.get(`/emissoras`, {
          signal: controller.signal,
        });

        if (data) {
          setEmissoras(
            data.map((emi: Emissora) => ({
              id: emi.id,
              label: emi.nome,
              siglapromo: emi.siglapromo,
            })),
          );
        } else toast.error('Falha de comunicação com o sistema');
      } catch (e) {
        setLoading(false);
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      }
    }
    buscaEmissoras();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function buscaChamadas() {
      setLoading(true);
      try {
        const response = await api.get('/chamadasts/calendar', {
          signal: controller.signal,
          params: {
            datainicio: format(date[0], 'yyyy-MM-dd'),
            datafim: format(date[1], 'yyyy-MM-dd'),
            ...(filter.setor && { setor: filter.setor }),
            ...(filter.retranca && { retranca: filter.retranca }),
            ...(filter.tipo &&
              filter.tipo.length > 0 && { tipo: filter.tipo.join() }),
            ...(filter.emissora &&
              filter.emissora.length > 0 && {
                emissoras: filter.emissora.join(),
              }),
          },
        });
        if (response && response.data) {
          setEvents(
            response.data.map((r: Chamada) => ({
              id: r.id,
              title:
                (r.tipo === Tipo.PROMOCIONAL && r.descricao
                  ? `${r.descricao} | `
                  : '') +
                `${r.retranca} (${format(
                  new Date(r.datainicio),
                  'dd/MM',
                )} - ${format(new Date(r.datafim), 'dd/MM')})`,
              start: new Date(r.datainicio),
              end: addDays(new Date(r.datafim), 1),
              allDay: true,
              backgroundColor: theme.calendar[r.tipo],
              textColor: theme.secondaryFontColor,
              borderColor: 'transparent',
            })),
          );
        }
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      }
      setLoading(false);
    }
    buscaChamadas();
    return () => {
      controller.abort();
    };
  }, [date, filter, theme.calendar, theme.secondaryFontColor]);

  return (
    <Container>
      <header>
        <h4>CALENDÁRIO DE PRODUÇÕES</h4>
        <Button
          id="closefilter"
          fill
          color="font"
          round
          onClick={() => {
            setShowFilter(!showFilter);
            setSelectedEvent({} as EventApi);
          }}
        >
          {showFilter ? <FiX /> : <FiSearch />}
        </Button>
      </header>
      <Content>
        <Card>
          {loading ? (
            <Calendar
              events={[]}
              handleChangeDate={handleChangeDate}
              handleEventClick={handleEventClick}
            />
          ) : (
            <Calendar
              events={events}
              handleChangeDate={handleChangeDate}
              handleEventClick={handleEventClick}
            />
          )}
        </Card>
        {showFilter &&
          (selectedEvent.id ? (
            <RightContent>
              <Form ref={formRef} onSubmit={handleSubmitUpdateDates}>
                <section>
                  <h5>Retranca: </h5>
                </section>

                <Field
                  tag="h3"
                  loading={loadingUpdate}
                  value={selectedEvent.title.slice(
                    0,
                    selectedEvent.title.lastIndexOf('('),
                  )}
                />
                {/* <h3>{selectedEvent.title}</h3> */}
                <div>
                  <section>
                    <h5>Período de veiculação:</h5>
                  </section>
                  <div className="column">
                    <DatePicker
                      selected={selectedStartDate}
                      onChange={(date: Date) => setSelectedStartDate(date)}
                      placeholderText="DE"
                      name="datainicio"
                      disabled={loading}
                    />

                    <DatePicker
                      onChange={(date: Date) => setSelectedEndDate(date)}
                      selected={selectedEndDate}
                      placeholderText="ATÉ"
                      name="datafim"
                      disabled={loading}
                    />
                  </div>
                </div>
                <div className="column">
                  <Button
                    type="submit"
                    disabled={loadingUpdate}
                    color="primary"
                  >
                    {!loadingUpdate ? 'SALVAR' : <Spinner type="ThreeDots" />}
                  </Button>
                </div>
              </Form>
            </RightContent>
          ) : (
            <RightContent>
              <Form
                ref={formFilterRef}
                onSubmit={handleSubmit}
                initialData={initialData}
              >
                <section>
                  <h5>Retranca: </h5>
                </section>
                <Input
                  name="retranca"
                  placeholder="Retranca"
                  icon={<FiSearch />}
                />

                <section>
                  <h5>Setor: </h5>
                </section>
                <Radio
                  name="setor"
                  options={DataFilter.setores}
                  disabled={loading}
                />
                <section>
                  <h5>Tipos: </h5>
                  <Button
                    fill
                    color="primary"
                    size="xsm"
                    onClick={e => handleTodos(e)}
                  >
                    TODOS ? {todosTipos ? 'SIM' : 'NÃO'}
                  </Button>
                </section>
                <Checkbox
                  name="tipo"
                  columns="1fr 1fr 1fr"
                  options={DataFilter.tipos}
                  disabled={loading}
                  handleSelected={handleSelectedTipo}
                />
                <section>
                  <h5>Emissoras: </h5>
                  <Button
                    fill
                    color="primary"
                    size="xsm"
                    onClick={e => handleRede(e)}
                  >
                    REDE ? {rede ? 'SIM' : 'NÃO'}
                  </Button>
                </section>
                <Checkbox
                  name="emissora"
                  columns="1fr 1fr 1fr"
                  options={emissoras}
                  disabled={loading}
                  handleSelected={handleSelectedExibidor}
                />
                <Button type="submit" disabled={loading} color="primary">
                  {!loading ? 'FILTRAR' : <Spinner type="ThreeDots" />}
                </Button>
              </Form>
            </RightContent>
          ))}
      </Content>
    </Container>
  );
}
